export type listItemWithEmphsisProps = {
    strongText?: string;
    plainText: string;
};

export const ListItemWithEmphsis = (props: listItemWithEmphsisProps) => (
    <>
        {props.strongText ? <strong>{props.strongText}</strong> : ""}
        {props.plainText}
    </>
);
